<!-- 用量报表 -->
<template>
    <div class="container containerBox">
        <!-- 头部筛选区 -->
        <div class="handleForm">
            <el-form :inline="true" label-width="100px" :model="handleForm" class="demo-form-inline">
                <el-form-item label="住户名称">
                    <el-input v-model="handleForm.name" placeholder="请输入住户名称"></el-input>
                </el-form-item>
                <el-form-item label="楼宇选择">
                    <cmp-build-select 
                    :buildRoom="buildRoom"
                    changeOnSelect
                    @listenBuildResult="listenBuildResult"></cmp-build-select>
                </el-form-item>
                <el-form-item label="选择时间段">
                    <el-date-picker
                        v-model="handleForm.date"
                        type="daterange"
                        @change="handleDateChange"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <div class="fr">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <!-- <el-button type="primary" @click="handleExport">导出</el-button>
                        <el-button type="primary" @click="handlePrint">打印</el-button> -->
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>
    </div>
</template>

<script>
import Service from '@/api/Service'

import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import LbTable from '@/components/lb-table/lb-table'

import { getMaxHeigth, FormatDate, funFmtDevType, fmtHouseInfo, FormatUTCDate } from '@/utils/utils'

const nowDay = FormatDate("yyyy-MM-dd");
export default {
    name: 'usestatement',
    data () {
        return {
            // 搜索参数
            handleForm: {
                from: nowDay,
                to: nowDay,
                oid: '',
                date: [],
            },
            // 选择房间组件
            buildRoom: {},

            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'household_name',
                        label: "业主名称",
                    },
                    {
                        prop: 'house_name',
                        label: '房间号',
                        // render: (h, scope) => {
                        //     return (
                        //         <span>{ this.fmtHouse(scope.row) }</span>
                        //     )
                        // }
                    },
                    {
                        prop: 'terminal_serial',
                        label: '表计号',
                    },
                    {
                        prop: 'device_model',
                        label: '型号',
                    },
      //               {
      //                   prop: 'dev_type',
      //                   label: '类型',
      //                   sortable: true,
      //                   // render: (h, scope) => {return (<span>{ this.fmtDevType(scope.row) }</span>)},
						
      //               },
                    {
                        prop: 'sum_cool_usage',
                        label: '冷量总用量',
                    },
					{
					    prop: 'sum_heat_usage',
					    label: '热量总用量',
					},
                    {
                        prop: 'cool_start_count',
                        label: '冷量起始值',
                    },
                    {
                        prop: 'cool_end_count',
                        label: '冷量结束值',
                    },
					{
					    prop: 'heat_start_count',
					    label: '热量起始值',
					},
					{
					    prop: 'heat_end_count',
					    label: '热量结束值',
					    sortable: true,
					},
                    // {
                    //     prop: 'terminal_cost',
                    //     label: '费用',
                    //     sortable: true,
                    //     formatter: this.formatterTofix2
                    // },
                    {
                        prop: 'from',
                        label: '开始时间',
                        formatter: this.formatterDate1
                    },
                    {
                        prop: 'to',
                        label: '结束时间',
                        formatter: this.formatterDate2
                    },
					// {
					//     label: '操作',
					//     width: '180px',
					//     render: (h, scope) => {
					//     return (
					//         <div>
					//         <el-button
					//             size="mini"
					//             type="primary"
					            
					//             onClick={ () => { this.setcount(scope.row) } }>生成账单</el-button>
					//         </div>
					//     )
					//     }					
					// }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,
        };
    },
    components: { LbTable, CmpBuildSelect },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    created() {
        // this.getData();
    },
    methods: {
        // 获取数据
        async getData() {
            let params = {}
            params.ids = JSON.stringify([{oid: this.handleForm.oid}])
			params.household_name = this.handleForm.name
            params.from = this.handleForm.from;
            params.to = this.handleForm.to;
			params.is_house =this.handleForm.is_house;
            params.page_num = this.page_num;
            params.page_sum = this.page_sum;

            let res = await Service.getTerminalByidlist(params);
            if(res) {
                this.tableData.data = res.list || [];
                this.total = res.total
            }
        },
        // 最后一级房间确认信息
        listenBuildResult(data) {
			if(data.householdid === undefined) {
			    // 建筑
			    this.handleForm.is_house = false
			}else{
			    // 房间
			    this.handleForm.is_house = true
			}
            this.handleForm.oid = data.oid + '';
        },
        handleDateChange(val) {
            if(val) {
                this.handleForm.from = val[0]
                this.handleForm.to = val[1]
            }else{
                this.handleForm.from = nowDay
                this.handleForm.to = nowDay
            }
        },
        // 查询
        onSubmit() {
			if(this.handleForm.oid != ''){
				this.getData();
			}else{
				this.$message({
					message: '请选择建筑！！',
					ype: 'warning'
				});
				return
			}
        },
		//生成账单
		async setcount(row){
			row.from = this.handleForm.from
			row.to= this.handleForm.to
			let params={}
			params.from = this.handleForm.from + " 00:00:00";
			params.to = this.handleForm.to + " 00:00:00";
			params.household_id = row.household_id;
			let res = await Service.Generate(params);
			if(res){
				this.$router.push({path:'/ownerclose', query: {data:  JSON.stringify(this.handleForm)}});
			}
			// this.$router.push('/ownerclose/' + row)
			// this.oid = this.$route.params.id
		},
        // 导出
        handleExport() {

        },
        // 打印
        handlePrint() {

        },
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
        // 格式化表计类型
        fmtDevType(row) {
            return funFmtDevType(row.dev_type);
        },
        // // 安装位置
        // fmtHouse(row){
        //     return fmtHouseInfo(row.housename, row.moduleidlist);
        // },
        // formatterTofix1(row) {
        //     return row.terminal_usage.toFixed(2);
        // },
        // formatterTofix2(row) {
        //     return row.terminal_cost.toFixed(2);
        // },
        // formatterDate1(row) {
        //     if(row.from === '') {
        //         return ''
        //     }
        //     return FormatUTCDate(Date.parse(row.from), 'yyyy-MM-dd')
        // },
        // formatterDate2(row) {
        //     if(row.to === '') {
        //         return ''
        //     }
        //     return FormatUTCDate(Date.parse(row.to), 'yyyy-MM-dd')
        // }
    }
}

</script>
<style lang='css' scoped>
</style>